/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { dppEventsFromMultiAddToCart } from '@/data/dpp/fromGtm';
import { trackDppEvents } from '@/data/dpp/tracker';
import { sendGTMMultiAddToCartEvent } from '@/data/events/handlers/gtm/MultiAddToCart';
import { GTMMultiAddToCartPayload } from '@/data/types/GTM';

type MultiAddToCartDelegatorProps = {
	gtm?: GTMMultiAddToCartPayload;
};

export const multiAddToCartDelegator = async (payload: MultiAddToCartDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		trackDppEvents(dppEventsFromMultiAddToCart(gtm));
		await sendGTMMultiAddToCartEvent(gtm);
	}
};
